function toggleMenu() {
    // code to toggle menu
}

function closeMenu() {
    // code to close menu
}

export { toggleMenu, closeMenu };